// temp used for manually serving VMGs passback tags
class ZoneMap {
  constructor () {
    this._passback = null
  }

  passback (bid) {
    if (bid) {
      this._passback = bid
    } else {
      return this._passback
    }
  }
}

export default new ZoneMap()
